export const designSystemTokenValues = {
  color: {
    background: {
      page: "#ffffff",
      canvas: "#fefefe",
      surface: "#ffffff",
      subtle: "#f6f8fa",
      muted: "#e4e6ea",
      hover: "#e0e0e0",
      selected: "#eceef1",
      overlayLight: "rgba(0, 0, 0, 0.3)",
      overlay: "rgba(0, 0, 0, 0.45)",
      overlayStrong: "rgba(0, 0, 0, 0.5)",
      disabled: "#cdcdcd",
      disabledStrong: "#b5b5b8",
      transparent: "rgba(255, 255, 255, 0)",
      raised: "#f9f9f9",
      neutral: "#f5f5f5",
      quiet: "#f8f8f8",
      canvasMuted: "#fafafa",
      track: "#f1f1f1",
      surfaceTranslucent: "#ffffffee",
      surfaceMuted: "#ffffff98",
      infoTint: "#ddebfc39",
      dangerTint: "#f1ecec3b",
      successTint: "#c3eacc72",
      neutralTint: "#a8a6a418",
      hoverTint: "#e0e0e07c",
      infoSoft: "#dceeff",
      aquaSoft: "#e6f8fa",
      glass: "rgba(255, 255, 255, 0.92)",
      selection: "#f3f4f6",
      disabledControl: "#e4e1e1",
    },
    text: {
      primary: "#111621",
      formLabel: "#000000",
      secondary: "#292f3b",
      muted: "#595e69",
      inverse: "#fefefe",
      accent: "#111621",
      danger: "#b85555",
      disabled: "#465671",
      body: "#27292e",
      subdued: "#73767d",
      success: "#366d36",
      strong: "#202225",
      subtle: "#73767d",
      quiet: "#666666",
      placeholderStrong: "#999999",
      slate: "#6b7280",
      heading: "#0f172a",
      aiHeading: "#0d173d",
      ink: "#0d0e10",
      blackSoft: "#0a0a0a",
      graphite: "#292929",
      dark: "#232323",
      disabledSoft: "#7a7f89",
      blackMuted: "#0c0c0c",
      secondarySlate: "#5f6673",
      navigation: "#626875",
      neutralDark: "#344054",
      neutral: "#7a7a7a",
      charcoal: "#222222",
      darkStrong: "#1a1a1a",
      quietStrong: "#777777",
      disabledMuted: "#8a8a8a",
      teal: "rgba(4, 68, 88, 0.811)",
    },
    border: {
      subtle: "#dcdde1",
      soft: "#bec3cd",
      medium: "#898c91",
      strong: "#111621",
      accent: "#111621",
      danger: "#b85555",
      light: "#a3a3a3",
      transparent: "rgba(255, 255, 255, 0)",
      control: "#d1d5db",
      disabled: "#cccccc",
      muted: "#d6d8dc",
      quiet: "#e5e7eb",
      neutral: "#dddddd",
      input: "#969ba5",
      inputStrong: "#526885",
      compare: "#d7d7d7",
      default: "#d0d5dd",
      chart: "#d3d8e3",
      divider: "#e2e2e2",
      mutedStrong: "#9499a8",
      tag: "#858a93",
      icon: "#dce1e6",
      tableHeader: "#dfe1e5",
    },
    action: {
      primary: "#111621",
      primaryHover: "#292f3b",
      primaryHoverStrong: "#1a1f35",
      primaryPressed: "#000000",
      aiGradient:
        "linear-gradient(125deg, #0a0d15 6.17%, #1a1f35 28.09%, #2f3949 50%, #595e69 71.91%, #747f95 93.83%)",
      aiGradientHover:
        "linear-gradient(125deg, #000000 6.17%, #111621 40%, #465671 100%)",
      secondaryHover: "#e1e3e7",
      danger: "#b85555",
      dangerHover: "#964343",
      success: "#008000",
      successHover: "#006600",
      disabled: "#cdcdcd",
      selection: "#0000ff",
    },
    control: {
      background: "#ffffff",
      backgroundDisabled: "#cdcdcd",
      backgroundSubtle: "#f2f2f2",
      text: "#111621",
      textSubdued: "#333333",
      textEmpty: "#888888",
      placeholder: "#647085",
      border: "rgba(3, 3, 3, 0.76)",
      borderError: "#ea3438",
      errorText: "#db1517",
      required: "#ff0000",
      scrollbar: "#d1d1d1",
      scrollbarHover: "#a8a8a8",
    },
    feedback: {
      error: {
        border: "#ea3438",
        background: "#fce7e7",
        solid: "#e74c3c",
      },
      success: {
        border: "#008333",
        background: "#e0f0e7",
        solid: "#2ecc71",
      },
      info: {
        border: "#111621",
        background: "#111621",
        solid: "#111621",
      },
      warning: {
        border: "#111621",
        background: "#F0E68C",
        text: "#111621",
      },
    },
    focus: {
      inner: "#111621",
      center: "#fefefe",
      outer: "#111621",
    },
    icon: {
      primary: "#111621",
      inverse: "#fefefe",
      muted: "#898c91",
      danger: "#b85555",
      success: "#007b2e",
      positive: "#4a904a",
      positiveStrong: "#2d5a2d",
      info: "#4573af",
      neutral: "#5e5a57",
      ink: "#0a0d15",
      aiMid: "#2f3949",
    },
    dataVisualization: {
      one: { background: "#f7f8fd", border: "#c2ccf0", text: "#323e75" },
      two: { background: "#edf3fb", border: "#add8f0", text: "#245275" },
      four: { background: "#fbeef5", border: "#edc6dc", text: "#73375d" },
      five: {
        background: "#edf9f6",
        border: "#caeadf",
        accent: "#71c0a8",
        text: "#2d5a51",
        strongText: "#1a3830",
      },
      nine: { background: "#fafbfb", border: "#dcdde1", text: "#2e3137" },
      score: {
        excellent: "#005314",
        good: "#269652",
        caution: "#ff923f",
        cautionBackground: "#fff0e4",
        poor: "#ed5256",
      },
      comparison: {
        axis: "#465065",
        label: "#6b7280",
      },
    },
    status: {
      active: { border: "#66b066", background: "#eef8ed", text: "#1a3a1a" },
      pending: { border: "#6592d0", background: "#eef5fd", text: "#1a2e52" },
      deleted: { background: "#fceaea", text: "#3d1616" },
      disabled: { border: "#e5a84d", background: "#fff9eb", text: "#4a3012" },
      invited: { border: "#c973a3", text: "#482239" },
      company: { border: "#f9dcc4", background: "#fff6ed" },
      positive: { text: "#2e7d32", strong: "#0db429", muted: "#8ccf8c" },
      negative: { text: "#d32f2f", strong: "#e4272b", accent: "#e12124" },
      successAction: {
        background: "#10b981",
        hover: "#059669",
        disabled: "#90ee90",
      },
      destructiveAction: {
        background: "#ff4d4d",
        hover: "#e63939",
        successBackground: "#2ad753a8",
        successHover: "#28c047",
      },
    },
    workflow: {
      jobBrief: "#cab532",
      scorecard: "#9ebfeb",
      hiringProcess: "#63c6d4",
      jobDescription: "#f1b694",
      sourcing: "#6f9196",
      assessment: "#cb9d3a",
      assessmentSubtle: "#f8eed2",
      offer: "#d89b69",
      completed: "#8ccf8c",
      setup: "#afce77",
      archived: "#bdbfc7",
      evaluation: "#4f80c4",
      additional: "#e08970",
      muted: "#747f95",
      rose: "#d7abb5",
      cyan: "#3fb0c4",
    },
  },
  typography: {
    family: {
      sans: '"Inclusive Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      mono: 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace',
    },
    size: {
      px10: "10px",
      px11: "11px",
      px11_8: "11.8px",
      px11_808: "11.808px",
      xs: "11.81px",
      px12: "12px",
      px13: "13px",
      px13_6: "13.6px",
      px14: "14px",
      px14_16: "14.16px",
      sm: "14.17px",
      px14_2: "14.2px",
      px14_4: "14.4px",
      px14_7: "14.7px",
      px15: "15px",
      px15_5: "15.5px",
      px16: "16px",
      md: "17px",
      px18: "18px",
      px20: "20px",
      lg: "20.4px",
      px21: "21px",
      px22: "22px",
      px24: "24px",
      xl: "24.48px",
      px25: "25px",
      px30: "30px",
      px32_25: "32.25px",
      px34: "34px",
      px35: "35px",
      px35_25: "35.25px",
      px36: "36px",
      px42: "42px",
      px48: "48px",
      px50: "50px",
      px52: "52px",
      px55: "55px",
      px58: "58px",
      px64: "64px",
      px112: "112px",
      relative36: "0.36em",
      relativeHalf: "0.5em",
      keywordLarge: "large",
      keywordLarger: "larger",
      vw1_5: "1.5vw",
      vw1_8: "1.8vw",
      vw2_8: "2.8vw",
      vw4: "4vw",
      vw5: "5vw",
      vw8: "8vw",
    },
    lineHeight: {
      condensed: "0.9",
      tight: "1",
      snug: "1.2",
      control: "1.3",
      relaxed: "1.4",
      body: "1.5em",
      xs: "16px",
      px17_712: "17.712px",
      px10: "10px",
      px14: "14px",
      vw2_8: "2.8vw",
      px18: "18px",
      px20: "20px",
      px21_24: "21.24px",
      px21_255: "21.255px",
      px22: "22px",
      sm: "24px",
      md: "24px",
      px25_5: "25.5px",
      px26: "26px",
      px26_52: "26.52px",
      px27: "27px",
      lg: "28px",
      xl: "32px",
      px40: "40px",
      px48: "48px",
      px52: "52px",
    },
    weight: {
      light: "300",
      regular: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
    },
  },
  spacing: {
    none: "0",
    px1: "1px",
    xxs: "2px",
    px3: "3px",
    xs: "4px",
    px5: "5px",
    px5_5: "5.5px",
    px6: "6px",
    px7: "7px",
    sm: "8px",
    px9: "9px",
    px9_6: "9.6px",
    px10: "10px",
    px11: "11px",
    md: "12px",
    px13: "13px",
    px14: "14px",
    px15: "15px",
    lg: "16px",
    px17: "17px",
    px18: "18px",
    px19_2: "19.2px",
    px20: "20px",
    px22: "22px",
    xl: "24px",
    px25: "25px",
    px28: "28px",
    px29: "29px",
    px30: "30px",
    "2xl": "32px",
    px35: "35px",
    px36: "36px",
    "3xl": "40px",
    px42: "42px",
    px45: "45px",
    px46: "46px",
    px48: "48px",
    px50: "50px",
    px56: "56px",
    px60: "60px",
    px63: "63px",
    px64: "64px",
    px72: "72px",
    px80: "80px",
    px100: "100px",
    px120: "120px",
    px132: "132px",
    px190: "190px",
    percent1: "1%",
    percent2: "2%",
    mm2: "2mm",
    mm6: "6mm",
  },
  radius: {
    none: "0",
    "2xs": "2px",
    xxs: "3px",
    xs: "4px",
    compact: "5px",
    control: "6px",
    sm: "8px",
    relaxed: "10px",
    md: "12px",
    rounded: "15px",
    lg: "16px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "32px",
    "4xl": "50px",
    circle: "50%",
    full: "9999px",
  },
  borderWidth: {
    hairline: "0.5px",
    thin: "1px",
    emphasized: "1.5px",
    medium: "2px",
    thick: "4px",
  },
  shadow: {
    sm: "0 1px 4px rgba(0, 0, 0, 0.16)",
    compactDialog: "0 2px 8px rgba(0, 0, 0, 0.1)",
    popup: "0 4px 12px rgba(0, 0, 0, 0.1)",
    md: "0 4px 12px rgba(0, 0, 0, 0.18)",
    lg: "0 19px 38px rgba(0, 0, 0, 0.22)",
    dropdown:
      "0 19px 38px 0 rgba(0, 0, 0, 0.3), 0 15px 12px 0 rgba(0, 0, 0, 0.22)",
    panel: "-2px 0 10px rgba(0, 0, 0, 0.2)",
    tooltip: "1.95px 1.95px 2.6px 0 rgba(0, 0, 0, 0.15)",
    frozenLeft: "3px 0 6px -2px rgba(0, 0, 0, 0.2)",
    frozenRight: "-3px 0 6px -2px rgba(0, 0, 0, 0.2)",
    tableMenu: "0 8px 16px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)",
    navigation: "0 8px 16px rgba(64, 63, 63, 0.2)",
    header: "0 1px 3px 0 rgba(0, 0, 0, 0.35)",
    headerMenu: "4px 9px 8px rgba(0, 0, 0, 0.12)",
    headerEdge: "4px 0 6px -2px rgba(0, 0, 0, 0.12)",
    drag: "0 2px 6px rgba(0, 0, 0, 0.2)",
    raised: "0 6px 15px rgba(0, 0, 0, 0.25)",
    card: "0 4px 10px rgba(0, 0, 0, 0.1)",
    control: "0 4px 6px rgba(0, 0, 0, 0.1)",
    faint: "0 2px 8px rgba(0, 0, 0, 0.05)",
    darkSoft: "0 4px 8px rgba(17, 22, 33, 0.2)",
    bottom: "0 -2px 4px rgba(0, 0, 0, 0.1)",
  },
  motion: {
    fast: "120ms",
    normal: "200ms",
    slow: "300ms",
    processing: "700ms",
    attentionInterval: "10s",
    easing: "ease-in-out",
  },
  zIndex: {
    dropdown: "200",
    overlay: "900",
    dialog: "1000",
    toast: "9999",
  },
  layout: {
    contentMaxWidth: "1440px",
    pageContentMaxWidth: "1380px",
    pageInlineGutter: "30px",
    pageInlineGutterCompact: "15px",
    drawerWidth: "350px",
    taskModalWidth: "700px",
    taskModalBodyMaxHeight: "636px",
    aiContextModalWidth: "640px",
    aiContextPromptHeight: "110px",
    aiContextGenerateWidth: "144px",
    fixedActionClearance: "128px",
    topNavigationHeight: "61px",
  },
} as const;

export const designSystemVars = {
  color: {
    background: {
      page: "var(--inzeloop-ds-color-background-page)",
      canvas: "var(--inzeloop-ds-color-background-canvas)",
      surface: "var(--inzeloop-ds-color-background-surface)",
      subtle: "var(--inzeloop-ds-color-background-subtle)",
      muted: "var(--inzeloop-ds-color-background-muted)",
      hover: "var(--inzeloop-ds-color-background-hover)",
      selected: "var(--inzeloop-ds-color-background-selected)",
      overlayLight: "var(--inzeloop-ds-color-background-overlay-light)",
      overlay: "var(--inzeloop-ds-color-background-overlay)",
      overlayStrong: "var(--inzeloop-ds-color-background-overlay-strong)",
      disabled: "var(--inzeloop-ds-color-background-disabled)",
      disabledStrong: "var(--inzeloop-ds-color-background-disabled-strong)",
      transparent: "var(--inzeloop-ds-color-background-transparent)",
      raised: "var(--inzeloop-ds-color-background-raised)",
      neutral: "var(--inzeloop-ds-color-background-neutral)",
      quiet: "var(--inzeloop-ds-color-background-quiet)",
      canvasMuted: "var(--inzeloop-ds-color-background-canvas-muted)",
      track: "var(--inzeloop-ds-color-background-track)",
      surfaceTranslucent:
        "var(--inzeloop-ds-color-background-surface-translucent)",
      surfaceMuted: "var(--inzeloop-ds-color-background-surface-muted)",
      infoTint: "var(--inzeloop-ds-color-background-info-tint)",
      dangerTint: "var(--inzeloop-ds-color-background-danger-tint)",
      successTint: "var(--inzeloop-ds-color-background-success-tint)",
      neutralTint: "var(--inzeloop-ds-color-background-neutral-tint)",
      hoverTint: "var(--inzeloop-ds-color-background-hover-tint)",
      infoSoft: "var(--inzeloop-ds-color-background-info-soft)",
      aquaSoft: "var(--inzeloop-ds-color-background-aqua-soft)",
      glass: "var(--inzeloop-ds-color-background-glass)",
      selection: "var(--inzeloop-ds-color-background-selection)",
      disabledControl: "var(--inzeloop-ds-color-background-disabled-control)",
    },
    text: {
      primary: "var(--inzeloop-ds-color-text-primary)",
      formLabel: "var(--inzeloop-ds-color-text-form-label)",
      secondary: "var(--inzeloop-ds-color-text-secondary)",
      muted: "var(--inzeloop-ds-color-text-muted)",
      inverse: "var(--inzeloop-ds-color-text-inverse)",
      accent: "var(--inzeloop-ds-color-text-accent)",
      danger: "var(--inzeloop-ds-color-text-danger)",
      disabled: "var(--inzeloop-ds-color-text-disabled)",
      body: "var(--inzeloop-ds-color-text-body)",
      subdued: "var(--inzeloop-ds-color-text-subdued)",
      success: "var(--inzeloop-ds-color-text-success)",
      strong: "var(--inzeloop-ds-color-text-strong)",
      subtle: "var(--inzeloop-ds-color-text-subtle)",
      quiet: "var(--inzeloop-ds-color-text-quiet)",
      placeholderStrong: "var(--inzeloop-ds-color-text-placeholder-strong)",
      slate: "var(--inzeloop-ds-color-text-slate)",
      heading: "var(--inzeloop-ds-color-text-heading)",
      aiHeading: "var(--inzeloop-ds-color-text-ai-heading)",
      ink: "var(--inzeloop-ds-color-text-ink)",
      blackSoft: "var(--inzeloop-ds-color-text-black-soft)",
      graphite: "var(--inzeloop-ds-color-text-graphite)",
      dark: "var(--inzeloop-ds-color-text-dark)",
      disabledSoft: "var(--inzeloop-ds-color-text-disabled-soft)",
      blackMuted: "var(--inzeloop-ds-color-text-black-muted)",
      secondarySlate: "var(--inzeloop-ds-color-text-secondary-slate)",
      navigation: "var(--inzeloop-ds-color-text-navigation)",
      neutralDark: "var(--inzeloop-ds-color-text-neutral-dark)",
      neutral: "var(--inzeloop-ds-color-text-neutral)",
      charcoal: "var(--inzeloop-ds-color-text-charcoal)",
      darkStrong: "var(--inzeloop-ds-color-text-dark-strong)",
      quietStrong: "var(--inzeloop-ds-color-text-quiet-strong)",
      disabledMuted: "var(--inzeloop-ds-color-text-disabled-muted)",
      teal: "var(--inzeloop-ds-color-text-teal)",
    },
    border: {
      subtle: "var(--inzeloop-ds-color-border-subtle)",
      soft: "var(--inzeloop-ds-color-border-soft)",
      medium: "var(--inzeloop-ds-color-border-medium)",
      strong: "var(--inzeloop-ds-color-border-strong)",
      accent: "var(--inzeloop-ds-color-border-accent)",
      danger: "var(--inzeloop-ds-color-border-danger)",
      light: "var(--inzeloop-ds-color-border-light)",
      transparent: "var(--inzeloop-ds-color-border-transparent)",
      control: "var(--inzeloop-ds-color-border-control)",
      disabled: "var(--inzeloop-ds-color-border-disabled)",
      muted: "var(--inzeloop-ds-color-border-muted)",
      quiet: "var(--inzeloop-ds-color-border-quiet)",
      neutral: "var(--inzeloop-ds-color-border-neutral)",
      input: "var(--inzeloop-ds-color-border-input)",
      inputStrong: "var(--inzeloop-ds-color-border-input-strong)",
      compare: "var(--inzeloop-ds-color-border-compare)",
      default: "var(--inzeloop-ds-color-border-default)",
      chart: "var(--inzeloop-ds-color-border-chart)",
      divider: "var(--inzeloop-ds-color-border-divider)",
      mutedStrong: "var(--inzeloop-ds-color-border-muted-strong)",
      tag: "var(--inzeloop-ds-color-border-tag)",
      icon: "var(--inzeloop-ds-color-border-icon)",
      tableHeader: "var(--inzeloop-ds-color-border-table-header)",
    },
    action: {
      primary: "var(--inzeloop-ds-color-action-primary)",
      primaryHover: "var(--inzeloop-ds-color-action-primary-hover)",
      primaryHoverStrong:
        "var(--inzeloop-ds-color-action-primary-hover-strong)",
      primaryPressed: "var(--inzeloop-ds-color-action-primary-pressed)",
      aiGradient: "var(--inzeloop-ds-color-action-ai-gradient)",
      aiGradientHover: "var(--inzeloop-ds-color-action-ai-gradient-hover)",
      secondaryHover: "var(--inzeloop-ds-color-action-secondary-hover)",
      danger: "var(--inzeloop-ds-color-action-danger)",
      dangerHover: "var(--inzeloop-ds-color-action-danger-hover)",
      success: "var(--inzeloop-ds-color-action-success)",
      successHover: "var(--inzeloop-ds-color-action-success-hover)",
      disabled: "var(--inzeloop-ds-color-action-disabled)",
      selection: "var(--inzeloop-ds-color-action-selection)",
    },
    control: {
      background: "var(--inzeloop-ds-color-control-background)",
      backgroundDisabled:
        "var(--inzeloop-ds-color-control-background-disabled)",
      backgroundSubtle: "var(--inzeloop-ds-color-control-background-subtle)",
      text: "var(--inzeloop-ds-color-control-text)",
      textSubdued: "var(--inzeloop-ds-color-control-text-subdued)",
      textEmpty: "var(--inzeloop-ds-color-control-text-empty)",
      placeholder: "var(--inzeloop-ds-color-control-placeholder)",
      border: "var(--inzeloop-ds-color-control-border)",
      borderError: "var(--inzeloop-ds-color-control-border-error)",
      errorText: "var(--inzeloop-ds-color-control-error-text)",
      required: "var(--inzeloop-ds-color-control-required)",
      scrollbar: "var(--inzeloop-ds-color-control-scrollbar)",
      scrollbarHover: "var(--inzeloop-ds-color-control-scrollbar-hover)",
    },
    feedback: {
      error: {
        border: "var(--inzeloop-ds-color-feedback-error-border)",
        background: "var(--inzeloop-ds-color-feedback-error-background)",
        solid: "var(--inzeloop-ds-color-feedback-error-solid)",
      },
      success: {
        border: "var(--inzeloop-ds-color-feedback-success-border)",
        background: "var(--inzeloop-ds-color-feedback-success-background)",
        solid: "var(--inzeloop-ds-color-feedback-success-solid)",
      },
      info: {
        border: "var(--inzeloop-ds-color-feedback-info-border)",
        background: "var(--inzeloop-ds-color-feedback-info-background)",
        solid: "var(--inzeloop-ds-color-feedback-info-solid)",
      },
      warning: {
        border: "var(--inzeloop-ds-color-feedback-warning-border)",
        background: "var(--inzeloop-ds-color-feedback-warning-background)",
        text: "var(--inzeloop-ds-color-feedback-warning-text)",
      },
    },
    icon: {
      primary: "var(--inzeloop-ds-color-icon-primary)",
      inverse: "var(--inzeloop-ds-color-icon-inverse)",
      muted: "var(--inzeloop-ds-color-icon-muted)",
      danger: "var(--inzeloop-ds-color-icon-danger)",
      success: "var(--inzeloop-ds-color-icon-success)",
      positive: "var(--inzeloop-ds-color-icon-positive)",
      positiveStrong: "var(--inzeloop-ds-color-icon-positive-strong)",
      info: "var(--inzeloop-ds-color-icon-info)",
      neutral: "var(--inzeloop-ds-color-icon-neutral)",
      ink: "var(--inzeloop-ds-color-icon-ink)",
      aiMid: "var(--inzeloop-ds-color-icon-ai-mid)",
    },
    dataVisualization: {
      one: {
        background: "var(--inzeloop-ds-color-data-viz-one-background)",
        border: "var(--inzeloop-ds-color-data-viz-one-border)",
        text: "var(--inzeloop-ds-color-data-viz-one-text)",
      },
      two: {
        background: "var(--inzeloop-ds-color-data-viz-two-background)",
        border: "var(--inzeloop-ds-color-data-viz-two-border)",
        text: "var(--inzeloop-ds-color-data-viz-two-text)",
      },
      four: {
        background: "var(--inzeloop-ds-color-data-viz-four-background)",
        border: "var(--inzeloop-ds-color-data-viz-four-border)",
        text: "var(--inzeloop-ds-color-data-viz-four-text)",
      },
      five: {
        background: "var(--inzeloop-ds-color-data-viz-five-background)",
        border: "var(--inzeloop-ds-color-data-viz-five-border)",
        accent: "var(--inzeloop-ds-color-data-viz-five-accent)",
        text: "var(--inzeloop-ds-color-data-viz-five-text)",
        strongText: "var(--inzeloop-ds-color-data-viz-five-strong-text)",
      },
      nine: {
        background: "var(--inzeloop-ds-color-data-viz-nine-background)",
        border: "var(--inzeloop-ds-color-data-viz-nine-border)",
        text: "var(--inzeloop-ds-color-data-viz-nine-text)",
      },
      score: {
        excellent: "var(--inzeloop-ds-color-data-viz-score-excellent)",
        good: "var(--inzeloop-ds-color-data-viz-score-good)",
        caution: "var(--inzeloop-ds-color-data-viz-score-caution)",
        cautionBackground:
          "var(--inzeloop-ds-color-data-viz-score-caution-background)",
        poor: "var(--inzeloop-ds-color-data-viz-score-poor)",
      },
      comparison: {
        axis: "var(--inzeloop-ds-color-data-viz-comparison-axis)",
        label: "var(--inzeloop-ds-color-data-viz-comparison-label)",
      },
    },
    status: {
      active: {
        border: "var(--inzeloop-ds-color-status-active-border)",
        background: "var(--inzeloop-ds-color-status-active-background)",
        text: "var(--inzeloop-ds-color-status-active-text)",
      },
      pending: {
        border: "var(--inzeloop-ds-color-status-pending-border)",
        background: "var(--inzeloop-ds-color-status-pending-background)",
        text: "var(--inzeloop-ds-color-status-pending-text)",
      },
      deleted: {
        background: "var(--inzeloop-ds-color-status-deleted-background)",
        text: "var(--inzeloop-ds-color-status-deleted-text)",
      },
      disabled: {
        border: "var(--inzeloop-ds-color-status-disabled-border)",
        background: "var(--inzeloop-ds-color-status-disabled-background)",
        text: "var(--inzeloop-ds-color-status-disabled-text)",
      },
      invited: {
        border: "var(--inzeloop-ds-color-status-invited-border)",
        text: "var(--inzeloop-ds-color-status-invited-text)",
      },
      company: {
        border: "var(--inzeloop-ds-color-status-company-border)",
        background: "var(--inzeloop-ds-color-status-company-background)",
      },
      positive: {
        text: "var(--inzeloop-ds-color-status-positive-text)",
        strong: "var(--inzeloop-ds-color-status-positive-strong)",
        muted: "var(--inzeloop-ds-color-status-positive-muted)",
      },
      negative: {
        text: "var(--inzeloop-ds-color-status-negative-text)",
        strong: "var(--inzeloop-ds-color-status-negative-strong)",
        accent: "var(--inzeloop-ds-color-status-negative-accent)",
      },
      successAction: {
        background: "var(--inzeloop-ds-color-status-success-action-background)",
        hover: "var(--inzeloop-ds-color-status-success-action-hover)",
        disabled: "var(--inzeloop-ds-color-status-success-action-disabled)",
      },
      destructiveAction: {
        background:
          "var(--inzeloop-ds-color-status-destructive-action-background)",
        hover: "var(--inzeloop-ds-color-status-destructive-action-hover)",
        successBackground:
          "var(--inzeloop-ds-color-status-destructive-action-success-background)",
        successHover:
          "var(--inzeloop-ds-color-status-destructive-action-success-hover)",
      },
    },
    workflow: {
      jobBrief: "var(--inzeloop-ds-color-workflow-job-brief)",
      scorecard: "var(--inzeloop-ds-color-workflow-scorecard)",
      hiringProcess: "var(--inzeloop-ds-color-workflow-hiring-process)",
      jobDescription: "var(--inzeloop-ds-color-workflow-job-description)",
      sourcing: "var(--inzeloop-ds-color-workflow-sourcing)",
      assessment: "var(--inzeloop-ds-color-workflow-assessment)",
      assessmentSubtle: "var(--inzeloop-ds-color-workflow-assessment-subtle)",
      offer: "var(--inzeloop-ds-color-workflow-offer)",
      completed: "var(--inzeloop-ds-color-workflow-completed)",
      setup: "var(--inzeloop-ds-color-workflow-setup)",
      archived: "var(--inzeloop-ds-color-workflow-archived)",
      evaluation: "var(--inzeloop-ds-color-workflow-evaluation)",
      additional: "var(--inzeloop-ds-color-workflow-additional)",
      muted: "var(--inzeloop-ds-color-workflow-muted)",
      rose: "var(--inzeloop-ds-color-workflow-rose)",
      cyan: "var(--inzeloop-ds-color-workflow-cyan)",
    },
  },
  typography: {
    family: {
      sans: "var(--inzeloop-ds-font-family-sans)",
      mono: "var(--inzeloop-ds-font-family-mono)",
    },
    size: {
      px10: "var(--inzeloop-ds-font-size-10px)",
      px11: "var(--inzeloop-ds-font-size-11px)",
      px11_8: "var(--inzeloop-ds-font-size-11-8px)",
      px11_808: "var(--inzeloop-ds-font-size-11-808px)",
      xs: "var(--inzeloop-ds-font-size-xs)",
      px12: "var(--inzeloop-ds-font-size-12px)",
      px13: "var(--inzeloop-ds-font-size-13px)",
      px13_6: "var(--inzeloop-ds-font-size-13-6px)",
      px14: "var(--inzeloop-ds-font-size-14px)",
      px14_16: "var(--inzeloop-ds-font-size-14-16px)",
      sm: "var(--inzeloop-ds-font-size-sm)",
      px14_2: "var(--inzeloop-ds-font-size-14-2px)",
      px14_4: "var(--inzeloop-ds-font-size-14-4px)",
      px14_7: "var(--inzeloop-ds-font-size-14-7px)",
      px15: "var(--inzeloop-ds-font-size-15px)",
      px15_5: "var(--inzeloop-ds-font-size-15-5px)",
      px16: "var(--inzeloop-ds-font-size-16px)",
      md: "var(--inzeloop-ds-font-size-md)",
      px18: "var(--inzeloop-ds-font-size-18px)",
      px20: "var(--inzeloop-ds-font-size-20px)",
      lg: "var(--inzeloop-ds-font-size-lg)",
      px21: "var(--inzeloop-ds-font-size-21px)",
      px22: "var(--inzeloop-ds-font-size-22px)",
      px24: "var(--inzeloop-ds-font-size-24px)",
      xl: "var(--inzeloop-ds-font-size-xl)",
      px25: "var(--inzeloop-ds-font-size-25px)",
      px30: "var(--inzeloop-ds-font-size-30px)",
      px32_25: "var(--inzeloop-ds-font-size-32-25px)",
      px34: "var(--inzeloop-ds-font-size-34px)",
      px35: "var(--inzeloop-ds-font-size-35px)",
      px35_25: "var(--inzeloop-ds-font-size-35-25px)",
      px36: "var(--inzeloop-ds-font-size-36px)",
      px42: "var(--inzeloop-ds-font-size-42px)",
      px48: "var(--inzeloop-ds-font-size-48px)",
      px50: "var(--inzeloop-ds-font-size-50px)",
      px52: "var(--inzeloop-ds-font-size-52px)",
      px55: "var(--inzeloop-ds-font-size-55px)",
      px58: "var(--inzeloop-ds-font-size-58px)",
      px64: "var(--inzeloop-ds-font-size-64px)",
      px112: "var(--inzeloop-ds-font-size-112px)",
      relative36: "var(--inzeloop-ds-font-size-relative-36)",
      relativeHalf: "var(--inzeloop-ds-font-size-relative-half)",
      keywordLarge: "var(--inzeloop-ds-font-size-keyword-large)",
      keywordLarger: "var(--inzeloop-ds-font-size-keyword-larger)",
      vw1_5: "var(--inzeloop-ds-font-size-1-5vw)",
      vw1_8: "var(--inzeloop-ds-font-size-1-8vw)",
      vw2_8: "var(--inzeloop-ds-font-size-2-8vw)",
      vw4: "var(--inzeloop-ds-font-size-4vw)",
      vw5: "var(--inzeloop-ds-font-size-5vw)",
      vw8: "var(--inzeloop-ds-font-size-8vw)",
    },
    lineHeight: {
      condensed: "var(--inzeloop-ds-line-height-condensed)",
      tight: "var(--inzeloop-ds-line-height-tight)",
      snug: "var(--inzeloop-ds-line-height-snug)",
      control: "var(--inzeloop-ds-line-height-control)",
      relaxed: "var(--inzeloop-ds-line-height-relaxed)",
      body: "var(--inzeloop-ds-line-height-body)",
      xs: "var(--inzeloop-ds-line-height-xs)",
      px17_712: "var(--inzeloop-ds-line-height-17-712px)",
      px10: "var(--inzeloop-ds-line-height-10px)",
      px14: "var(--inzeloop-ds-line-height-14px)",
      vw2_8: "var(--inzeloop-ds-line-height-2-8vw)",
      px18: "var(--inzeloop-ds-line-height-18px)",
      px20: "var(--inzeloop-ds-line-height-20px)",
      px21_24: "var(--inzeloop-ds-line-height-21-24px)",
      px21_255: "var(--inzeloop-ds-line-height-21-255px)",
      px22: "var(--inzeloop-ds-line-height-22px)",
      sm: "var(--inzeloop-ds-line-height-sm)",
      md: "var(--inzeloop-ds-line-height-md)",
      px25_5: "var(--inzeloop-ds-line-height-25-5px)",
      px26: "var(--inzeloop-ds-line-height-26px)",
      px26_52: "var(--inzeloop-ds-line-height-26-52px)",
      px27: "var(--inzeloop-ds-line-height-27px)",
      lg: "var(--inzeloop-ds-line-height-lg)",
      xl: "var(--inzeloop-ds-line-height-xl)",
      px40: "var(--inzeloop-ds-line-height-40px)",
      px48: "var(--inzeloop-ds-line-height-48px)",
      px52: "var(--inzeloop-ds-line-height-52px)",
    },
    weight: {
      light: "var(--inzeloop-ds-font-weight-light)",
      regular: "var(--inzeloop-ds-font-weight-regular)",
      medium: "var(--inzeloop-ds-font-weight-medium)",
      semibold: "var(--inzeloop-ds-font-weight-semibold)",
      bold: "var(--inzeloop-ds-font-weight-bold)",
    },
  },
  spacing: {
    none: "var(--inzeloop-ds-spacing-none)",
    px1: "var(--inzeloop-ds-spacing-1px)",
    xxs: "var(--inzeloop-ds-spacing-xxs)",
    px3: "var(--inzeloop-ds-spacing-3px)",
    xs: "var(--inzeloop-ds-spacing-xs)",
    px5: "var(--inzeloop-ds-spacing-5px)",
    px5_5: "var(--inzeloop-ds-spacing-5-5px)",
    px6: "var(--inzeloop-ds-spacing-6px)",
    px7: "var(--inzeloop-ds-spacing-7px)",
    sm: "var(--inzeloop-ds-spacing-sm)",
    px9: "var(--inzeloop-ds-spacing-9px)",
    px9_6: "var(--inzeloop-ds-spacing-9-6px)",
    px10: "var(--inzeloop-ds-spacing-10px)",
    px11: "var(--inzeloop-ds-spacing-11px)",
    md: "var(--inzeloop-ds-spacing-md)",
    px13: "var(--inzeloop-ds-spacing-13px)",
    px14: "var(--inzeloop-ds-spacing-14px)",
    px15: "var(--inzeloop-ds-spacing-15px)",
    lg: "var(--inzeloop-ds-spacing-lg)",
    px17: "var(--inzeloop-ds-spacing-17px)",
    px18: "var(--inzeloop-ds-spacing-18px)",
    px19_2: "var(--inzeloop-ds-spacing-19-2px)",
    px20: "var(--inzeloop-ds-spacing-20px)",
    px22: "var(--inzeloop-ds-spacing-22px)",
    xl: "var(--inzeloop-ds-spacing-xl)",
    px25: "var(--inzeloop-ds-spacing-25px)",
    px28: "var(--inzeloop-ds-spacing-28px)",
    px29: "var(--inzeloop-ds-spacing-29px)",
    px30: "var(--inzeloop-ds-spacing-30px)",
    "2xl": "var(--inzeloop-ds-spacing-2xl)",
    px35: "var(--inzeloop-ds-spacing-35px)",
    px36: "var(--inzeloop-ds-spacing-36px)",
    "3xl": "var(--inzeloop-ds-spacing-3xl)",
    px42: "var(--inzeloop-ds-spacing-42px)",
    px45: "var(--inzeloop-ds-spacing-45px)",
    px46: "var(--inzeloop-ds-spacing-46px)",
    px48: "var(--inzeloop-ds-spacing-48px)",
    px50: "var(--inzeloop-ds-spacing-50px)",
    px56: "var(--inzeloop-ds-spacing-56px)",
    px60: "var(--inzeloop-ds-spacing-60px)",
    px63: "var(--inzeloop-ds-spacing-63px)",
    px64: "var(--inzeloop-ds-spacing-64px)",
    px72: "var(--inzeloop-ds-spacing-72px)",
    px80: "var(--inzeloop-ds-spacing-80px)",
    px100: "var(--inzeloop-ds-spacing-100px)",
    px120: "var(--inzeloop-ds-spacing-120px)",
    px132: "var(--inzeloop-ds-spacing-132px)",
    px190: "var(--inzeloop-ds-spacing-190px)",
    percent1: "var(--inzeloop-ds-spacing-percent-1)",
    percent2: "var(--inzeloop-ds-spacing-percent-2)",
    mm2: "var(--inzeloop-ds-spacing-2mm)",
    mm6: "var(--inzeloop-ds-spacing-6mm)",
  },
  radius: {
    none: "var(--inzeloop-ds-radius-none)",
    "2xs": "var(--inzeloop-ds-radius-2xs)",
    xxs: "var(--inzeloop-ds-radius-xxs)",
    xs: "var(--inzeloop-ds-radius-xs)",
    compact: "var(--inzeloop-ds-radius-compact)",
    control: "var(--inzeloop-ds-radius-control)",
    sm: "var(--inzeloop-ds-radius-sm)",
    relaxed: "var(--inzeloop-ds-radius-relaxed)",
    md: "var(--inzeloop-ds-radius-md)",
    rounded: "var(--inzeloop-ds-radius-rounded)",
    lg: "var(--inzeloop-ds-radius-lg)",
    xl: "var(--inzeloop-ds-radius-xl)",
    "2xl": "var(--inzeloop-ds-radius-2xl)",
    "3xl": "var(--inzeloop-ds-radius-3xl)",
    "4xl": "var(--inzeloop-ds-radius-4xl)",
    circle: "var(--inzeloop-ds-radius-circle)",
    full: "var(--inzeloop-ds-radius-full)",
  },
  borderWidth: {
    hairline: "var(--inzeloop-ds-border-width-hairline)",
    thin: "var(--inzeloop-ds-border-width-thin)",
    emphasized: "var(--inzeloop-ds-border-width-emphasized)",
    medium: "var(--inzeloop-ds-border-width-medium)",
    thick: "var(--inzeloop-ds-border-width-thick)",
  },
  shadow: {
    sm: "var(--inzeloop-ds-shadow-sm)",
    compactDialog: "var(--inzeloop-ds-shadow-compact-dialog)",
    popup: "var(--inzeloop-ds-shadow-popup)",
    md: "var(--inzeloop-ds-shadow-md)",
    lg: "var(--inzeloop-ds-shadow-lg)",
    dropdown: "var(--inzeloop-ds-shadow-dropdown)",
    panel: "var(--inzeloop-ds-shadow-panel)",
    tooltip: "var(--inzeloop-ds-shadow-tooltip)",
    frozenLeft: "var(--inzeloop-ds-shadow-frozen-left)",
    frozenRight: "var(--inzeloop-ds-shadow-frozen-right)",
    tableMenu: "var(--inzeloop-ds-shadow-table-menu)",
    navigation: "var(--inzeloop-ds-shadow-navigation)",
    header: "var(--inzeloop-ds-shadow-header)",
    headerMenu: "var(--inzeloop-ds-shadow-header-menu)",
    headerEdge: "var(--inzeloop-ds-shadow-header-edge)",
    drag: "var(--inzeloop-ds-shadow-drag)",
    raised: "var(--inzeloop-ds-shadow-raised)",
    card: "var(--inzeloop-ds-shadow-card)",
    control: "var(--inzeloop-ds-shadow-control)",
    faint: "var(--inzeloop-ds-shadow-faint)",
    darkSoft: "var(--inzeloop-ds-shadow-dark-soft)",
    bottom: "var(--inzeloop-ds-shadow-bottom)",
    focus: "var(--inzeloop-ds-shadow-focus)",
  },
  motion: {
    fast: "var(--inzeloop-ds-motion-fast)",
    normal: "var(--inzeloop-ds-motion-normal)",
    slow: "var(--inzeloop-ds-motion-slow)",
    processing: "var(--inzeloop-ds-motion-processing)",
    attentionInterval: "var(--inzeloop-ds-motion-attention-interval)",
    easing: "var(--inzeloop-ds-motion-easing)",
  },
  zIndex: {
    dropdown: "var(--inzeloop-ds-z-index-dropdown)",
    overlay: "var(--inzeloop-ds-z-index-overlay)",
    dialog: "var(--inzeloop-ds-z-index-dialog)",
    toast: "var(--inzeloop-ds-z-index-toast)",
  },
  layout: {
    contentMaxWidth: "var(--inzeloop-ds-layout-content-max-width)",
    pageContentMaxWidth: "var(--inzeloop-ds-layout-page-content-max-width)",
    pageInlineGutter: "var(--inzeloop-ds-layout-page-inline-gutter)",
    pageInlineGutterCompact:
      "var(--inzeloop-ds-layout-page-inline-gutter-compact)",
    drawerWidth: "var(--inzeloop-ds-layout-drawer-width)",
    taskModalWidth: "var(--inzeloop-ds-layout-task-modal-width)",
    taskModalBodyMaxHeight:
      "var(--inzeloop-ds-layout-task-modal-body-max-height)",
    aiContextModalWidth: "var(--inzeloop-ds-layout-ai-context-modal-width)",
    aiContextPromptHeight: "var(--inzeloop-ds-layout-ai-context-prompt-height)",
    aiContextGenerateWidth:
      "var(--inzeloop-ds-layout-ai-context-generate-width)",
    fixedActionClearance: "var(--inzeloop-ds-layout-fixed-action-clearance)",
    topNavigationHeight: "var(--inzeloop-ds-layout-top-navigation-height)",
  },
} as const;
